var elementHasFocus = function elementHasFocus(element) {
  return document.activeElement === element;
};

export default elementHasFocus;